import { createFileRoute, redirect } from '@tanstack/react-router'
import { JournalsScreen } from '@/features/accounting-journals/journals-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/journals')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_settings.edit'))
      throw redirect({ to: '/accounting' })
  },
  component: JournalsScreen,
})
